import { IMAGE_CORRUPTED, MediaAddon, MediaImage } from 'editor/src/store/design/types';

function isImageEmpty(element: MediaAddon | MediaImage) {
  return element.type === 'image' && (!element.imageId || element.imageId === IMAGE_CORRUPTED);
}

export default isImageEmpty;
